<!--
 * @Author: your name
 * @Date: 2021-09-07 18:55:00
 * @LastEditTime: 2021-09-09 11:41:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/coursePrice.vue
-->
<!--  -->
<template>
  <div class="priceModule-price ">
    <!-- 免费 -->
    <p class="free_price" v-if="!courseBaseData.sellPrice">
      <span class="nowPrice">限时免费</span>
      <span class="originalPrice" v-if="courseBaseData.originalPrice"
        >￥{{ courseBaseData.originalPrice }}</span
      >
    </p>
    <p v-else>
      <span class="priceSymbol">￥</span>
      <span class="nowPrice">{{ calculationPrice(courseBaseData.sellPrice).b }}</span>
      <span class="nowPrice">{{ calculationPrice(courseBaseData.sellPrice).s }}</span>
      <span class="originalPrice" v-if="courseBaseData.originalPrice"
        >￥{{ courseBaseData.originalPrice }}</span
      >
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { priceCount } from '@/utils/tools';

export default {
  data() {
    return {
      version: '',
    };
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  mounted() {},
  methods: {
    // // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
  },
};
</script>

<style lang="scss" scoped>
.priceModule-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 36px 36px;
  // $pubColor: #ff6c02;
  // $pubGrayColor: #787878;
  background: #fff;
  border-radius: 0 0 14px 14px;
  // .free_price {
  //   color: #ff6c02;
  //   font-size: 33px;
  // }
  > p {
    line-height: 33px;

    .priceSymbol {
      margin-left: -2px;
      padding-right: 4px;
      color: #ff6c02;
      font-size: 22px;
    }

    .nowPrice {
      color: #ff6c02;
      font-weight: 600;
      font-size: 33px;
    }

    .originalPrice {
      padding-left: 30px;
      color: #a5a5a5;
      font-size: 25px;
      text-decoration: line-through;
    }

    .freeText {
      color: #ff6c02;
      font-size: 36px;
    }

    .alreadyBuyNumber {
      color: #ff6c02;
      font-size: 22px;
    }

    .alreadyBuyText {
      padding-left: 10px;
      color: #a5a5a5;
      font-size: 22px;
    }
  }
}
</style>
